import { render, staticRenderFns } from "./base-home-user.vue?vue&type=template&id=790b9a04&scoped=true&"
import script from "./base-home-user.vue?vue&type=script&lang=ts&"
export * from "./base-home-user.vue?vue&type=script&lang=ts&"
import style0 from "./base-home-user.vue?vue&type=style&index=0&id=790b9a04&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "790b9a04",
  null
  
)

export default component.exports